import React from 'react';
import { disableMultipleClicks } from '../disableMultipleClickHOC';
import { TicketActionButton, FullColoredTicketButton, ButtonIcon } from '../../common/buttonsComponents';

export const TicketButton = ({
  className,
  onClick,
  children,
  fullColored,
  active = true,
  buttonId,
  label,
  showCloseIcon,
  ...props
}) => {
  const ButtonComponent = fullColored ? FullColoredTicketButton : TicketActionButton;

  // TO DO: currently, 'active' controls styles, 'disabled' controls disabling of the button
  // we need to consolidate functionality under 'disabled'
  return (
    <ButtonComponent
      name="ButtonComponent"
      active={active}
      className={className}
      onClick={onClick}
      id={buttonId}
      {...props}
    >
      {children}
      {showCloseIcon && <ButtonIcon src="/images/new-designs/close-x.svg" alt="back-button" />}
      {label}
    </ButtonComponent>
  );
};

export default disableMultipleClicks(TicketButton);
